import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {
  BlackTypography,
  PrimaryButton,
  PrimaryNormalFormHelperText,
  PrimaryNormalInputLabel,
  PrimaryNormalInputs,
  SecondaryFilledButton,
} from "assets/Mui/globalTheme";
import { useForm } from "react-hook-form";
import { FormControl, Grid, Stack } from "@mui/material";
import {
  LocalizationProvider,
  MobileDatePicker,
  MobileDateTimePicker,
} from "@mui/x-date-pickers";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
};
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  createAdminStaff,
  getSingleAdminStaffDetails,
  updateAdminStaff,
} from "helpers/services/adminStaff/adminStaff";
import {
  createCompanyStaff,
  getSingleCompanyStaffDetails,
  updateCompanyStaff,
} from "helpers/services/companies/company";
import {
  createBackgroundVerificationCompanyStaff,
  getSingleBackgroundVerificationStaffDetails,
  updateBackgroundVerificationCompanyStaff,
} from "helpers/services/BackgroundVerifications/backgroundVerifications";
import {
  createRecrutementCompanyStaff,
  getSingleRecrutementStaffDetails,
} from "helpers/services/RecrutementCompany/recrutement";

export default function StaffModel({
  purpose,
  role,
  backendData,
  id,
  headTag,
  isOpen,
  toggle,
  updated,
  isApprove
}) {
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  React.useEffect(() => {
    if (purpose === "EDIT") fillEditFieldValues();
  }, [purpose]);

  async function fillEditFieldValues() {
    if (role === "RC") {
      const { data: currentData } = await getSingleRecrutementStaffDetails(id);
      setValue("first_name", currentData.first_name);
      setValue("last_name", currentData.last_name);
      setValue("email", currentData.email);
    } else if (role === "ZA") {
      const currentData = await getSingleAdminStaffDetails(id);
      setValue("first_name", currentData.first_name);
      setValue("last_name", currentData.last_name);
      setValue("email", currentData.email);
    } else if (role === "CA") {
      const currentData = await getSingleCompanyStaffDetails(id);
      setValue("first_name", currentData.first_name);
      setValue("last_name", currentData.last_name);
      setValue("email", currentData.email);
    } else {
      const { data: currentData } =
        await getSingleBackgroundVerificationStaffDetails(id);
      setValue("first_name", currentData.first_name);
      setValue("last_name", currentData.last_name);
      setValue("email", currentData.email);
    }
  }
  const updateOrEditStaff = async data => {
    if (purpose === "EDIT") {
      delete data.user_password;
      switch (role) {
        case "ZA":
          await updateAdminStaff({ ...data,isApprove }, id);
          break;
        case "CA":
          await updateCompanyStaff({ ...data }, id);
          break;

        case "BVC":
          await updateBackgroundVerificationCompanyStaff({ ...data }, id);
          break;
        default:
          return null;
      }
    } else {
      switch (role) {
        case "ZA":
          await createAdminStaff({ ...data, usertype: backendData,isApprove });
          break;
        case "CA":
          await createCompanyStaff({ ...data, usertype: backendData });
          break;
        case "BVC":
          await createBackgroundVerificationCompanyStaff({
            ...data,
            usertype: backendData,
          });
          break;
        case "RC":
          await createRecrutementCompanyStaff({
            ...data,
            usertype: backendData,
          });
          break;
        default:
          return null;
      }
    }
    updated();
    toggle();
    setValue("first_name", "");
    setValue("last_name", "");
    setValue("email", "");
    setValue("user_password", "");
  };
  return (
    <div>
      <Modal
        open={isOpen}
        onClose={() => {
          toggle();
          reset();
        }}
        aria-labelledby="edit-profile-modal-first_name"
        aria-describedby="edit-profile-modal-description"
      >
        <Box sx={style}>
          <BlackTypography variant="h2" sx={{ marginBottom: "10px" }}>
            {headTag}{" "}
          </BlackTypography>
          <form onSubmit={handleSubmit(updateOrEditStaff)}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <FormControl sx={{ width: "100%" }} variant="standard">
                  <PrimaryNormalInputLabel
                    shrink
                    htmlFor="work-exp-first-name-outlined"
                    error={errors.first_name}
                  >
                    First name
                  </PrimaryNormalInputLabel>
                  <PrimaryNormalInputs
                    fullWidth
                    placeholder="Enter your first_name"
                    {...register("first_name", { required: true })}
                    id="wor-exp-first-name-outlined"
                    helperText={
                      errors?.first_name ? "first  name is required" : ""
                    }
                    autoFocus
                    label="Job first_name"
                    type={"text"}
                    name="first_name"
                    error={errors.first_name}
                    variant="outlined"
                  />
                  <PrimaryNormalFormHelperText error={errors.first_name}>
                    {errors.first_name ? "first name is required Field" : ""}
                  </PrimaryNormalFormHelperText>
                </FormControl>
              </Grid>
              <Grid item md={6}>
                <FormControl sx={{ width: "100%" }} variant="standard">
                  <PrimaryNormalInputLabel
                    shrink
                    htmlFor="work-exp-last-name-outlined"
                    error={errors.last_name}
                  >
                    Last name
                  </PrimaryNormalInputLabel>
                  <PrimaryNormalInputs
                    fullWidth
                    placeholder="Enter your Last Name"
                    {...register("last_name", { required: true })}
                    id="wor-exp-last-name-outlined"
                    helperText={
                      errors?.last_name ? "last  name is required" : ""
                    }
                    autoFocus
                    label=" last name"
                    type={"text"}
                    name="last_name"
                    error={errors.last_name}
                    variant="outlined"
                  />
                  <PrimaryNormalFormHelperText error={errors.last_name}>
                    {errors.last_name ? "last name is required Field" : ""}
                  </PrimaryNormalFormHelperText>
                </FormControl>
              </Grid>
              <Grid item md={12}>
                <FormControl sx={{ width: "100%" }} variant="standard">
                  <PrimaryNormalInputLabel
                    shrink
                    htmlFor="work-exp-email-outlined"
                    error={errors.email}
                  >
                    Email
                  </PrimaryNormalInputLabel>
                  <PrimaryNormalInputs
                    fullWidth
                    placeholder="Enter your email"
                    {...register("email", { required: true })}
                    id="wor-exp-email-outlined"
                    helperText={errors?.email ? "email is required" : ""}
                    autoFocus
                    label=" email"
                    type={"email"}
                    name="email"
                    error={errors.email}
                    variant="outlined"
                  />
                  <PrimaryNormalFormHelperText error={errors.email}>
                    {errors.email ? "email is required Field" : ""}
                  </PrimaryNormalFormHelperText>
                </FormControl>
              </Grid>
              {purpose !== "EDIT" && (
                <Grid item md={12}>
                  <FormControl sx={{ width: "100%" }} variant="standard">
                    <PrimaryNormalInputLabel
                      shrink
                      htmlFor="user-password-outlined"
                      error={errors.user_password}
                    >
                      password
                    </PrimaryNormalInputLabel>
                    <PrimaryNormalInputs
                      fullWidth
                      placeholder="Enter your password"
                      {...register("user_password", {
                        required: false,
                      })}
                      id="user-password-outlined"
                      helperText={
                        errors?.user_password ? "password is required" : ""
                      }
                      autoFocus
                      label=" user_password"
                      type={"password"}
                      name="user_password"
                      error={errors.user_password}
                      variant="outlined"
                    />
                    <PrimaryNormalFormHelperText error={errors.user_password}>
                      {errors.user_password ? "password is required Field" : ""}
                    </PrimaryNormalFormHelperText>
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={7}></Grid>
              <Grid item xs={5}>
                <Stack spacing={1} direction="row">
                  <SecondaryFilledButton
                    onClick={() => {
                      toggle();
                      reset();
                    }}
                  >
                    cancel
                  </SecondaryFilledButton>
                  <PrimaryButton type="submit">Submit</PrimaryButton>
                </Stack>{" "}
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
